<template>
  <div>
    <Navbar activeDirectory="home"></Navbar>
    
    <!-- Vista Sviluppatore Campania Sistemi -->
    <DeveloperDashboard v-if="tipologia === 'D'"></DeveloperDashboard>

    <div class="container-fluid" v-else>
      <div class="row">
        <div class="col-12">
          <div class="row">
            <div :class="kpiColClass" v-if="isModuleActive('manutenzione_strade') && isKpiActive('buche_riparate')">
              <div class="au-card widget-inline w-100">
                <div class="d-flex align-items-center">
                  <div class="bg-soft-primary p-3 rounded-circle mr-3">
                    <i class="mdi h3 m-0 text-primary" :class="[{'mdi-forklift': !reportLoading}, {'mdi-refresh rotate-icon' : reportLoading}]"></i>
                  </div>
                  <div>
                    <h4 class="m-0 font-weight-bold">{{ (report.bucheRiparate || 0).toLocaleString() }}</h4>
                    <p class="text-muted mb-0 small text-uppercase font-weight-semibold">Buche Riparate</p>
                  </div>
                </div>
              </div>
            </div>
            <div :class="kpiColClass" v-if="isModuleActive('verde_pubblico') && isKpiActive('metri_sfalciati')">
              <div class="au-card widget-inline w-100">
                <div class="d-flex align-items-center">
                  <div class="bg-soft-success p-3 rounded-circle mr-3">
                    <i class="mdi h3 m-0 text-success" :class="[{'mdi-ruler': !reportLoading}, {'mdi-refresh rotate-icon' : reportLoading}]"></i>
                  </div>
                  <div>
                    <h4 class="m-0 font-weight-bold">{{ (report.metriSfalciati || 0).toLocaleString() }}</h4>
                    <p class="text-muted mb-0 small text-uppercase font-weight-semibold">Metri Sfalciati</p>
                  </div>
                </div>
              </div>
            </div>
            <div :class="kpiColClass" v-if="isModuleActive('verde_pubblico') && isKpiActive('alberi_potati')">
              <div class="au-card widget-inline w-100">
                <div class="d-flex align-items-center">
                  <div class="bg-soft-success p-3 rounded-circle mr-3">
                    <i class="mdi h3 m-0 text-success" :class="[{'mdi-pine-tree': !reportLoading}, {'mdi-refresh rotate-icon' : reportLoading}]"></i>
                  </div>
                  <div>
                    <h4 class="m-0 font-weight-bold">{{ (report.alberiPotati || 0).toLocaleString() }}</h4>
                    <p class="text-muted mb-0 small text-uppercase font-weight-semibold">Alberi Potati</p>
                  </div>
                </div>
              </div>
            </div>
            <div :class="kpiColClass" v-if="isModuleActive('verde_pubblico') && isKpiActive('interventi_irrigazione')">
              <div class="au-card widget-inline w-100">
                <div class="d-flex align-items-center">
                  <div class="bg-soft-success p-3 rounded-circle mr-3">
                    <i class="mdi h3 m-0 text-success" :class="[{'mdi-water': !reportLoading}, {'mdi-refresh rotate-icon' : reportLoading}]"></i>
                  </div>
                  <div>
                    <h4 class="m-0 font-weight-bold">{{ (report.interventiIrrigazione || 0).toLocaleString() }}</h4>
                    <p class="text-muted mb-0 small text-uppercase font-weight-semibold">Interventi Irrigazione</p>
                  </div>
                </div>
              </div>
            </div>
            <div :class="kpiColClass" v-if="isModuleActive('pulizia_stradale') && isKpiActive('interventi_igiene')">
              <div class="au-card widget-inline w-100">
                <div class="d-flex align-items-center">
                  <div class="bg-soft-info p-3 rounded-circle mr-3">
                    <i class="mdi h3 m-0 text-info" :class="[{'mdi-trash-can-outline': !reportLoading}, {'mdi-refresh rotate-icon' : reportLoading}]"></i>
                  </div>
                  <div>
                    <h4 class="m-0 font-weight-bold">{{ (report.interventiIgiene || 0).toLocaleString() }}</h4>
                    <p class="text-muted mb-0 small text-uppercase font-weight-semibold">Interventi Igiene</p>
                  </div>
                </div>
              </div>
            </div>
            <div :class="kpiColClass" v-if="isModuleActive('illuminazione') && isKpiActive('punti_luce_ripristinati')">
              <div class="au-card widget-inline w-100">
                <div class="d-flex align-items-center">
                  <div class="bg-soft-warning p-3 rounded-circle mr-3">
                    <i class="mdi h3 m-0 text-warning" :class="[{'mdi-lightbulb-on-outline': !reportLoading}, {'mdi-refresh rotate-icon' : reportLoading}]"></i>
                  </div>
                  <div>
                    <h4 class="m-0 font-weight-bold">{{ (report.puntiLuceRipristinati || 0).toLocaleString() }}</h4>
                    <p class="text-muted mb-0 small text-uppercase font-weight-semibold">Punti Luce Ripristinati</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row mt-n2">
        <div class="col-12 col-lg-3 mb-3 mb-lg-0">
          <div class="au-card mb-3 shadow-sm border-0">
            <h5 class="text-muted text-uppercase small font-weight-bold mb-3 d-flex align-items-center">
              <i class="mdi mdi-bell-outline mr-2 text-warning"></i> Notifiche Push
            </h5>
            <div class="d-flex align-items-center justify-content-between">
              <div v-if="permission == 'denied' || permission == 'default'">
                <button class="btn btn-warning btn-sm shadow-sm font-weight-bold" @click="changeNotificationPermission()">Abilita</button>
              </div>
              <span v-else class="badge badge-soft-success px-3 py-2 rounded-pill font-weight-bold">
                <i class="mdi mdi-check-circle mr-1"></i> Abilitate
              </span>
            </div>
          </div>

          <div class="au-card shadow-sm border-0 mb-3">
            <div class="d-flex align-items-center">
              <div class="bg-soft-info p-3 rounded-circle mr-3">
                <i class="mdi h3 m-0 text-info" :class="[{'mdi-truck': !reportLoading}, {'mdi-refresh rotate-icon' : reportLoading}]"></i>
              </div>
              <div>
                <h4 class="m-0 font-weight-bold">{{ report.squadreAttive }} / {{ report.squadreTotali }}</h4>
                <p class="text-muted mb-0 small text-uppercase font-weight-semibold">Squadre Attive</p>
              </div>
            </div>
          </div>

          <div class="au-card shadow-sm border-0">
            <div class="d-flex align-items-center">
              <div class="bg-soft-warning p-3 rounded-circle mr-3">
                <i class="mdi h3 m-0 text-warning" :class="[{'mdi-road': !reportLoading}, {'mdi-refresh rotate-icon' : reportLoading}]"></i>
              </div>
              <div>
                <h4 class="m-0 font-weight-bold">{{ report.strade }}</h4>
                <p class="text-muted mb-0 small text-uppercase font-weight-semibold">Cantieri</p>
              </div>
            </div>
          </div>
        </div>
        <div class="col-12 col-lg-9">
          <!-- Schede -->
          <div class="text-left mb-2">
            <button
              class="btn btn-sm px-4 mr-2 shadow-sm font-weight-bold"
              :class="[{'btn-primary':activeView=='Segnalazioni inviate'},{'btn-light': activeView!='Segnalazioni inviate'}]"
              @click="activeView='Segnalazioni inviate'"
            >
              Segnalazioni inviate
              <span
                class="badge badge-pill ml-1"
                :class="[{'badge-success':activeView=='Segnalazioni inviate'},{'badge-secondary': activeView!='Segnalazioni inviate'}]"
              >{{ segnalazioni.length }}</span>              
            </button>
            <button
              class="btn btn-sm px-4 mr-2 shadow-sm font-weight-bold"
              :class="[{'btn-primary':activeView=='Richieste di supporto'},{'btn-light': activeView!='Richieste di supporto'}]"
              @click="activeView='Richieste di supporto'"
            >
              Richieste di supporto
              <span
                class="badge badge-pill ml-1"
                :class="[{'badge-success':activeView=='Richieste di supporto'},{'badge-secondary': activeView!='Richieste di supporto'}]"
              >{{ richieste.length }}</span>
            </button>
            <button
              class="btn btn-sm px-4 mr-2 shadow-sm font-weight-bold"
              :class="[{'btn-primary':activeView=='Lavori in corso'},{'btn-light': activeView!='Lavori in corso'}]"
              @click="activeView='Lavori in corso'"
            >
              Lavori in corso
              <span
                class="badge badge-pill ml-1"
                :class="[{'badge-success':activeView=='Lavori in corso'},{'badge-secondary': activeView!='Lavori in corso'}]"
              >{{ lavori.length }}</span>
            </button>
            <button
              class="btn btn-sm px-4 shadow-sm font-weight-bold"
              :class="[{'btn-danger':activeView=='Emergenze'},{'btn-light': activeView!='Emergenze'}]"
              @click="activeView='Emergenze'"
            >
              Emergenze
              <span
                class="badge badge-pill ml-1"
                :class="[{'badge-light text-danger':activeView=='Emergenze'},{'badge-secondary': activeView!='Emergenze'}]"
              >{{ emergenze.length }}</span>              
            </button>
          </div>
          <!-- Contenuto scheda -->
          <div class="au-card mb-4 p-0 overflow-hidden">
            <div class="p-4">
              <div class="text-left">
                <h3 class="font-bold">{{ activeView }}</h3>
                <span class="pull-right">
                  <i class="fa fa-refresh fa-2x" style="cursor: pointer;" @click="fetchData()"></i>
                </span>
              </div>

              <!-- Header delle schede -->
              <div class="text-left" v-if="activeView=='Lavori in corso'">
                <h5 >In questo momento, in questa commessa, sono attivi i seguenti cantieri</h5>
              </div>
              <div class="text-left" v-if="activeView=='Segnalazioni inviate'">
                <h5 >Le seguenti squadre hanno individuato e segnalato i seguenti interventi</h5>
              </div>
              <div class="text-left" v-if="activeView=='Richieste di supporto'">
                <h5 >Le seguenti squadre hanno bisogno supporto</h5>
              </div>
              <div class="text-left" v-if="activeView=='Emergenze'">
                <h5 >Elenco delle emergenze. Clicca su <i class="fa fa-eye"></i> per impostarle come lette</h5>
              </div>
              <div class="text-left">
                <span class="badge text-uppercase mr-1" :class="classeInterventoBadge('buca')" v-if="activeView!='Emergenze' && isModuleActive('manutenzione_strade')">Buca</span>
                <span class="badge text-uppercase mr-1" :class="classeInterventoBadge('sfalcio')" v-if="activeView!='Emergenze' && isModuleActive('verde_pubblico')">Sfalcio</span>
                <span class="badge text-uppercase mr-1" :class="classeInterventoBadge('segnaletica')" v-if="activeView!='Emergenze' && isModuleActive('manutenzione_strade')">Segnaletica</span>
                <span class="badge text-uppercase mr-1" :class="classeInterventoBadge('pulizia')" v-if="activeView!='Emergenze' && isModuleActive('pulizia_stradale')">Pulizia</span>
                <span class="badge text-uppercase mr-1" :class="classeInterventoBadge('rifiuto')" v-if="activeView=='Emergenze' && isModuleActive('pulizia_stradale')">Rifiuto</span>
                <span class="badge text-uppercase mr-1" :class="classeInterventoBadge('rifiuto_speciale')" v-if="activeView=='Emergenze' && isModuleActive('pulizia_stradale')">Rifiuto Spec.</span>
                <span class="badge text-uppercase mr-1" :class="classeInterventoBadge('emergenza_carreggiata')" v-if="activeView=='Emergenze' && (isModuleActive('pulizia_stradale') || isModuleActive('manutenzione_strade'))">Emergenza Carr.</span>                
              </div>
              <!-- Contenitore -->
              <div class="table-responsive mt-2">
                <!-- Segnalazioni -->
                <div v-if="activeView=='Segnalazioni inviate'">
                  <div class="progress m-b-20"><div class="progress-bar" :class="[{'bg-primary': progressBarSegnalazioni >= 100}, {'bg-success': progressBarSegnalazioni < 100}]" role="progressbar" :style="{width: `${this.progressBarSegnalazioni}%`}" :aria-valuenow="progressBarSegnalazioni" aria-valuemin="0" aria-valuemax="100"></div></div>
                </div>
                <table class="au-table" v-if="activeView=='Segnalazioni inviate' && segnalazioni.length > 0">
                  <thead>
                    <th>ID</th>
                    <th>Intervento</th>
                    <th>Segnalato da</th>
                    <th>In data</th>
                    <th>Presso</th>
                    <th v-if="segnalazioneDaAssociare!=0"></th>
                    <th class="text-right">Azioni</th>
                  </thead>
                  <tbody>
                    <tr v-for="(item, key) in segnalazioni" v-bind:key="key">
                      <td class="align-middle font-weight-bold text-muted">#{{ item.id }}</td>
                      <td class="align-middle"><span class="badge-soft" :class="classeInterventoBadge(item.intervento)">{{ nomeIntervento(item.intervento) }}</span></td>
                      <td class="align-middle font-weight-semibold">{{ item.team_segnalatore.nome }}</td>
                      <td class="align-middle text-muted small">{{ formatTimestampToLocalDate(item.tempo) }}</td>
                      <td class="align-middle">{{ item.strada }}</td>
                      <!-- Segnalazione da associare -->
                      <td class="align-middle text-right" v-if="segnalazioneDaAssociare==item.id">
                        <select class="form-control form-control-sm" style="width: 160px;" v-model="teamDaAssociareASegnalazione">
                          <option v-for="(item, key) in allTeams" v-bind:key="key" :value="item.uid">{{ item.team }}</option>
                        </select>                                                                     
                      </td>
                      <td class="align-middle text-right" v-if="segnalazioneDaAssociare==item.id">
                        <button @click="segnalazioneDaAssociare=0;" class="btn btn-light btn-sm mr-2" v-tooltip="{content:'Annulla', placement: 'top'}"><i class="mdi mdi-close"></i></button>
                        <button @click="associaSegnalazioneASquadra()" class="btn btn-success btn-sm mr-2" v-tooltip="{content:'Invia', placement: 'top'}"><i class="mdi mdi-check"></i></button>
                      </td>
                      <td v-if="segnalazioneDaAssociare!=item.id && segnalazioneDaAssociare!=0"></td>
                      <!-- Pulsanti di default -->
                      <td class="align-middle text-right" v-if="segnalazioneDaAssociare!=item.id">
                        <button @click="mostraDettagliSegnalazione(item)" class="btn btn-sm btn-outline-primary border-0 mr-1" v-tooltip="{content:'Dettagli', placement: 'top'}"><i class="mdi mdi-eye-outline h5 mb-0"></i></button>
                        <button @click="segnalazioneDaAssociare=item.id" v-if="item.intervento == 'buca' || item.intervento == 'sfalcio' || item.intervento == 'segnaletica'" class="btn btn-sm btn-outline-success border-0 mr-1" v-tooltip="{content:'Assegna', placement: 'top'}"><i class="mdi mdi-account-plus h5 mb-0"></i></button>
                        <button @click="impostaSegnalazioneComeLetta(item.id)" v-if="item.intervento == 'rifiuto' || item.intervento == 'rifiuto_speciale' || item.intervento == 'emergenza_carreggiata'" class="btn btn-sm btn-outline-danger border-0 mr-1" v-tooltip="{content:'Archivia', placement: 'top'}"><i class="mdi mdi-archive-outline h5 mb-0"></i></button>
                      </td>
                    </tr>
                  </tbody>
                </table>
                <div class="empty-state" v-if="activeView=='Segnalazioni inviate' && segnalazioni.length == 0">
                  <i class="mdi mdi-check-circle-outline"></i>
                  <h5>Tutto sotto controllo</h5>
                  <p>Non ci sono nuove segnalazioni inviate dalle squadre in questo momento.</p>
                </div>
                
                <!-- Richieste di Supporto -->
                <div v-if="activeView=='Richieste di supporto'">
                  <div class="progress m-b-20"><div class="progress-bar" :class="[{'bg-primary': progressBarRichieste >= 100}, {'bg-success': progressBarRichieste < 100}]" role="progressbar" :style="{width: `${progressBarRichieste}%`}" :aria-valuenow="progressBarRichieste" aria-valuemin="0" aria-valuemax="100"></div></div>
                </div>
                <table class="au-table" v-if="activeView=='Richieste di supporto' && richieste.length > 0">
                  <thead>
                    <th>ID</th>
                    <th>Intervento</th>
                    <th>Richiesto da</th>
                    <th>In data</th>
                    <th>Presso</th>
                    <th v-if="richiestaDaAssociare!=0"></th>
                    <th class="text-right">Azioni</th>
                  </thead>
                  <tbody>
                    <tr v-for="(item, key) in richieste" v-bind:key="key">
                      <td class="align-middle font-weight-bold text-muted">#{{ item.id }}</td>
                      <td class="align-middle"><span class="badge-soft" :class="classeInterventoBadge(item.intervento)">{{ nomeIntervento(item.intervento) }}</span></td>
                      <td class="align-middle font-weight-semibold">{{ item.team_richiedente.nome }}</td>
                      <td class="align-middle text-muted small">{{ formatTimestampToLocalDate(item.tempo) }}</td>
                      <td class="align-middle">{{ item.strada }}</td>
                      <!-- Segnalazione da associare -->
                      <td class="align-middle text-right" v-if="richiestaDaAssociare==item.id">
                        <select class="form-control form-control-sm" style="width: 160px;" v-model="teamDaAssociareARichiesta">
                          <option v-for="(item, key) in allTeams" v-bind:key="key" :value="item.uid">{{ item.team }}</option>
                        </select>                                                                     
                      </td>
                      <td class="align-middle text-right" v-if="richiestaDaAssociare==item.id">
                        <button @click="richiestaDaAssociare=0;" class="btn btn-light btn-sm mr-2" v-tooltip="{content:'Annulla', placement: 'top'}"><i class="mdi mdi-close"></i></button>
                        <button @click="associaRichiestaASquadra()" class="btn btn-success btn-sm mr-2" v-tooltip="{content:'Invia', placement: 'top'}"><i class="mdi mdi-check"></i></button>
                      </td>
                      <td v-if="richiestaDaAssociare!=item.id && richiestaDaAssociare!=0"></td>
                      <!-- Pulsanti di default -->
                      <td class="align-middle text-right" v-if="richiestaDaAssociare!=item.id">
                        <button @click="mostraDettagliRichiesta(item)" class="btn btn-sm btn-outline-primary border-0 mr-1" v-tooltip="{content:'Dettagli', placement: 'top'}"><i class="mdi mdi-eye-outline h5 mb-0"></i></button>
                        <button @click="richiestaDaAssociare=item.id" class="btn btn-sm btn-outline-success border-0 mr-1" v-tooltip="{content:'Assegna', placement: 'top'}"><i class="mdi mdi-account-plus h5 mb-0"></i></button>
                      </td>
                    </tr>
                  </tbody>
                </table>
                <div class="empty-state" v-if="activeView=='Richieste di supporto' && richieste.length == 0">
                  <i class="mdi mdi-account-group-outline"></i>
                  <h5>Nessuna richiesta</h5>
                  <p>Al momento non ci sono squadre che hanno richiesto supporto aggiuntivo.</p>
                </div>

                <!-- Lavori in corso -->
                <div v-if="activeView=='Lavori in corso'">
                  <div class="progress m-b-20"><div class="progress-bar" :class="[{'bg-primary': progressBarLavori >= 100}, {'bg-success': progressBarLavori < 100}]" role="progressbar" :style="{width: `${progressBarLavori}%`}" :aria-valuenow="progressBarLavori" aria-valuemin="0" aria-valuemax="100"></div></div>
                </div>
                <table class="au-table" v-if="activeView=='Lavori in corso' && lavori.length > 0">
                  <thead>
                    <th>ID</th>
                    <th>Intervento</th>
                    <th>Squadra</th>
                    <th>Avviato in data</th>
                    <th>Presso</th>
                    <th class="text-right">Azioni</th>
                  </thead>
                  <tbody>
                    <tr v-for="(item, key) in lavori" v-bind:key="key">
                      <td class="align-middle font-weight-bold text-muted">#{{ item.id }}</td>
                      <td class="align-middle"><span class="badge-soft" :class="classeInterventoBadge(item.intervento)">{{ nomeIntervento(item.intervento) }}</span></td>
                      <td class="align-middle font-weight-semibold">{{ item.team.nome }}</td>
                      <td class="align-middle text-muted small">{{ formatTimestampToLocalDate(item.avvio) }}</td>
                      <td class="align-middle">{{ item.strada }}</td>
                      <td class="align-middle text-right">
                        <button @click="downloadLavoroPDF(item)" class="btn btn-sm btn-outline-danger border-0 mr-1" v-tooltip="{content:'Relazione PDF', placement: 'top'}"><i class="mdi mdi-file-pdf-box h5 mb-0"></i></button>
                        <button @click="mostraDettagliLavoro(item)" class="btn btn-sm btn-outline-primary border-0" v-tooltip="{content:'Dettagli', placement: 'top'}"><i class="mdi mdi-eye-outline h5 mb-0"></i></button>
                      </td>
                    </tr>
                  </tbody>
                </table>
                <div class="empty-state" v-if="activeView=='Lavori in corso' && lavori.length == 0">
                  <i class="mdi mdi-hard-hat"></i>
                  <h5>Nessun lavoro attivo</h5>
                  <p>In questo momento non ci sono cantieri o lavori in corso in questa commessa.</p>
                </div>

                <!-- Emergenze -->
                <div v-if="activeView=='Emergenze'">
                  <div class="progress m-b-20"><div class="progress-bar" :class="[{'bg-primary': progressBarEmergenze >= 100}, {'bg-success': progressBarEmergenze < 100}]" role="progressbar" :style="{width: `${this.progressBarEmergenze}%`}" :aria-valuenow="progressBarEmergenze" aria-valuemin="0" aria-valuemax="100"></div></div>
                </div>
                <table class="au-table" v-if="activeView=='Emergenze' && emergenze.length > 0">
                  <thead>
                    <th>ID</th>
                    <th>Intervento</th>
                    <th>Segnalato da</th>
                    <th>In data</th>
                    <th>Presso</th>
                    <th class="text-right">Azioni</th>
                  </thead>
                  <tbody>
                    <tr v-for="(item, key) in emergenze" v-bind:key="key">
                      <td class="align-middle font-weight-bold text-muted">#{{ item.id }}</td>
                      <td class="align-middle"><span class="badge-soft" :class="classeInterventoBadge(item.intervento)">{{ nomeIntervento(item.intervento) }}</span></td>
                      <td class="align-middle font-weight-semibold">{{ item.team_segnalatore.nome }}</td>
                      <td class="align-middle text-muted small">{{ formatTimestampToLocalDate(item.tempo) }}</td>
                      <td class="align-middle">{{ item.strada }}</td>
                      <td class="align-middle text-right">
                        <button @click="mostraDettagliEmergenza(item)" class="btn btn-sm btn-outline-danger border-0" v-tooltip="{content:'Leggi', placement: 'top'}"><i class="mdi mdi-eye-outline h5 mb-0"></i></button>
                      </td>
                    </tr>
                  </tbody>
                </table>
                <div class="empty-state" v-if="activeView=='Emergenze' && emergenze.length == 0">
                  <i class="mdi mdi-alert-circle-check-outline"></i>
                  <h5>Nessuna emergenza</h5>
                  <p>Ottimo! Tutte le emergenze sono state lette o non ci sono segnalazioni urgenti.</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- MODALI -->

    <!-- Modale di una SEGNALAZIONE -->
    <modal name="segnalazione" :adaptive="true" :max-width="850" width="90%" height="auto" :scrollable="true">
      <div v-if="forceRefreshSegnalazione && Object.entries(segnalazione).length > 0">
        <div class="card mb-0 border-0">
          <div class="modal-header-premium d-flex justify-content-between align-items-center">
            <h4 class="mb-0 font-weight-bold text-primary">Dettagli Segnalazione</h4>
            <button class="btn btn-light btn-sm rounded-circle" @click="$modal.hide('segnalazione')"><i class="mdi mdi-close"></i></button>
          </div>
          <div class="card-body p-4">
            <div class="row">
              <div class="col-md-5">
                <div class="rounded-lg overflow-hidden shadow-sm mb-3">
                  <img :src="segnalazione.foto" class="img-fluid w-100" style="object-fit: cover; max-height: 400px; border-radius: 12px;">
                </div>
              </div>
              <div class="col-md-7">
                <div class="modal-section-title"><i class="mdi mdi-information-outline"></i> Informazioni Generali</div>
                <div class="row">
                  <div class="col-6 detail-item">
                    <div class="detail-label">Tipo Intervento</div>
                    <div class="detail-value"><span class="badge-soft" :class="classeInterventoBadge(segnalazione.intervento)">{{ nomeIntervento(segnalazione.intervento) }}</span></div>
                  </div>
                  <div class="col-6 detail-item">
                    <div class="detail-label">Identificativo</div>
                    <div class="detail-value">#{{ segnalazione.id }}</div>
                  </div>
                  <div class="col-6 detail-item">
                    <div class="detail-label">Segnalato da</div>
                    <div class="detail-value"> {{ segnalazione.team_segnalatore.nome }}</div>
                  </div>
                  <div class="col-6 detail-item">
                    <div class="detail-label">In data</div>
                    <div class="detail-value"> {{ formatTimestampToLocalDate(segnalazione.tempo) }}</div>
                  </div>
                </div>

                <div class="modal-section-title mt-2"><i class="mdi mdi-map-marker-outline"></i> Posizione</div>
                <div class="detail-item">
                  <div class="detail-label">Indirizzo / Strada</div>
                  <div class="detail-value">{{ segnalazione.strada }}</div>
                </div>
                <div class="row">
                  <div class="col-6 detail-item">
                    <div class="detail-label">Latitudine</div>
                    <div class="detail-value font-family-monospace small text-muted">{{ segnalazione.latitudine }}</div>
                  </div>
                  <div class="col-6 detail-item">
                    <div class="detail-label">Longitudine</div>
                    <div class="detail-value font-family-monospace small text-muted">{{ segnalazione.longitudine }}</div>
                  </div>
                </div>

                <div class="modal-section-title mt-2"><i class="mdi mdi-note-text-outline"></i> Note</div>
                <div class="detail-item">
                  <p class="text-muted italic" v-if="segnalazione.note">{{ segnalazione.note }}</p>
                  <p class="text-muted italic small" v-else>Nessuna nota aggiuntiva</p>
                </div>

                <div class="mt-4 pt-3 border-top text-right">
                  <router-link :to="{name: 'modifica-segnalazione', params: {uuid: segnalazione.uuid}}" class="btn btn-primary px-4 shadow-sm" v-if="tipologia=='B'">
                    <i class="mdi mdi-pencil mr-1"></i> Modifica
                  </router-link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </modal>

    <!-- Modale di una RICHIESTA -->
    <modal name="richiesta" :adaptive="true" :max-width="850" width="90%" height="auto" :scrollable="true">
      <div v-if="forceRefreshRichiesta && Object.entries(richiesta).length > 0">
        <div class="card mb-0 border-0">
          <div class="modal-header-premium d-flex justify-content-between align-items-center">
            <h4 class="mb-0 font-weight-bold text-primary">Richiesta di Supporto</h4>
            <button class="btn btn-light btn-sm rounded-circle" @click="$modal.hide('richiesta')"><i class="mdi mdi-close"></i></button>
          </div>
          <div class="card-body p-4">
            <div class="row">
              <div class="col-md-5">
                <div class="rounded-lg overflow-hidden shadow-sm mb-3">
                  <img :src="richiesta.foto" class="img-fluid w-100" style="object-fit: cover; max-height: 400px; border-radius: 12px;">
                </div>
              </div>
              <div class="col-md-7">
                <div class="modal-section-title"><i class="mdi mdi-information-outline"></i> Informazioni Generali</div>
                <div class="row">
                  <div class="col-6 detail-item">
                    <div class="detail-label">Tipo Intervento</div>
                    <div class="detail-value"><span class="badge-soft" :class="classeInterventoBadge(richiesta.intervento)">{{ nomeIntervento(richiesta.intervento) }}</span></div>
                  </div>
                  <div class="col-6 detail-item">
                    <div class="detail-label">Identificativo</div>
                    <div class="detail-value">#{{ richiesta.id }}</div>
                  </div>
                  <div class="col-6 detail-item">
                    <div class="detail-label">Richiesto da</div>
                    <div class="detail-value">{{ richiesta.team_richiedente.nome }}</div>
                  </div>
                  <div class="col-6 detail-item">
                    <div class="detail-label">In data</div>
                    <div class="detail-value">{{ formatTimestampToLocalDate(richiesta.tempo) }}</div>
                  </div>
                </div>

                <div class="modal-section-title mt-2"><i class="mdi mdi-map-marker-outline"></i> Posizione</div>
                <div class="detail-item">
                  <div class="detail-label">Indirizzo / Strada</div>
                  <div class="detail-value">{{ richiesta.strada }}</div>
                </div>
                <div class="row">
                  <div class="col-6 detail-item">
                    <div class="detail-label">Latitudine</div>
                    <div class="detail-value font-family-monospace small text-muted">{{ richiesta.latitudine }}</div>
                  </div>
                  <div class="col-6 detail-item">
                    <div class="detail-label">Longitudine</div>
                    <div class="detail-value font-family-monospace small text-muted">{{ richiesta.longitudine }}</div>
                  </div>
                </div>

                <div class="modal-section-title mt-2"><i class="mdi mdi-note-text-outline"></i> Note</div>
                <div class="detail-item">
                  <p class="text-muted italic" v-if="richiesta.note">{{ richiesta.note }}</p>
                  <p class="text-muted italic small" v-else>Nessuna nota aggiuntiva</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>      
    </modal>

    <!-- Modale di un lavoro -->
    <modal name="lavoro" :adaptive="true" :max-width="850" width="90%" height="auto" :scrollable="true">
      <div v-if="forceRefreshLavoro && Object.entries(lavoro).length > 0">
        <div class="card mb-0 border-0">
          <div class="modal-header-premium d-flex justify-content-between align-items-center">
            <h4 class="mb-0 font-weight-bold text-primary">Dettagli Lavoro in Corso</h4>
            <button class="btn btn-light btn-sm rounded-circle" @click="$modal.hide('lavoro')"><i class="mdi mdi-close"></i></button>
          </div>
          <div class="card-body p-4">
            <div class="row">
              <div class="col-md-5">
                <div class="rounded-lg overflow-hidden shadow-sm mb-3">
                  <img :src="lavoro.foto" class="img-fluid w-100" style="object-fit: cover; max-height: 400px; border-radius: 12px;">
                </div>
              </div>
              <div class="col-md-7">
                <div class="modal-section-title"><i class="mdi mdi-information-outline"></i> Informazioni Lavoro</div>
                <div class="row">
                  <div class="col-6 detail-item">
                    <div class="detail-label">Tipo Intervento</div>
                    <div class="detail-value"><span class="badge-soft" :class="classeInterventoBadge(lavoro.intervento)">{{ nomeIntervento(lavoro.intervento) }}</span></div>
                  </div>
                  <div class="col-6 detail-item">
                    <div class="detail-label">Identificativo</div>
                    <div class="detail-value">#{{ lavoro.id }}</div>
                  </div>
                  <div class="col-6 detail-item">
                    <div class="detail-label">Squadra Esecutrice</div>
                    <div class="detail-value">{{ lavoro.team.nome }}</div>
                  </div>
                  <div class="col-6 detail-item">
                    <div class="detail-label">Data Avvio</div>
                    <div class="detail-value">{{ formatTimestampToLocalDate(lavoro.avvio) }}</div>
                  </div>
                </div>

                <div class="modal-section-title mt-2"><i class="mdi mdi-map-marker-outline"></i> Ubicazione</div>
                <div class="detail-item">
                  <div class="detail-label">Strada interessata</div>
                  <div class="detail-value font-weight-bold">{{ lavoro.strada }}</div>
                </div>

                <div class="row">
                  <div class="col-6 detail-item">
                    <div class="detail-label">Latitudine</div>
                    <div class="detail-value font-family-monospace small text-muted">{{ lavoro.latitudine }}</div>
                  </div>
                  <div class="col-6 detail-item">
                    <div class="detail-label">Longitudine</div>
                    <div class="detail-value font-family-monospace small text-muted">{{ lavoro.longitudine }}</div>
                  </div>
                </div>

                <div class="mt-4 pt-3 border-top text-right">
                  <button @click="downloadLavoroPDF(lavoro)" class="btn btn-outline-danger shadow-sm mr-2">
                    <i class="mdi mdi-file-pdf-box mr-1"></i> Relazione PDF
                  </button>
                  <router-link :to="{name: 'modifica-lavoro', params: {uuid: lavoro.uuid}}" class="btn btn-primary px-4 shadow-sm" v-if="tipologia=='B'">
                    <i class="mdi mdi-pencil mr-1"></i> Modifica
                  </router-link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>      
    </modal>

    <!-- Modale di una EMERGENZA -->
    <modal name="emergenza" :adaptive="true" :max-width="850" width="90%" height="auto" :scrollable="true">
      <div v-if="forceRefreshSegnalazione && Object.entries(emergenza).length > 0">
        <div class="card mb-0 border-0">
          <div class="modal-header-premium d-flex justify-content-between align-items-center bg-danger-soft">
            <h4 class="mb-0 font-weight-bold text-danger">Dettagli Emergenza</h4>
            <button class="btn btn-light btn-sm rounded-circle" @click="$modal.hide('emergenza')"><i class="mdi mdi-close"></i></button>
          </div>
          <div class="card-body p-4">
            <div class="row">
              <div class="col-md-5">
                <div class="rounded-lg overflow-hidden shadow-sm mb-3">
                  <img :src="emergenza.foto" class="img-fluid w-100" style="object-fit: cover; max-height: 400px; border-radius: 12px;">
                </div>
              </div>
              <div class="col-md-7">
                <div class="modal-section-title text-danger"><i class="mdi mdi-alert-outline"></i> Allerta Critica</div>
                <div class="row">
                  <div class="col-6 detail-item">
                    <div class="detail-label">Tipo Emergenza</div>
                    <div class="detail-value"><span class="badge-soft badge-soft-danger">{{ emergenza.intervento }}</span></div>
                  </div>
                  <div class="col-6 detail-item">
                    <div class="detail-label">Identificativo</div>
                    <div class="detail-value">#{{ emergenza.id }}</div>
                  </div>
                  <div class="col-6 detail-item">
                    <div class="detail-label">Rilevato da</div>
                    <div class="detail-value">{{ emergenza.team_segnalatore.nome }}</div>
                  </div>
                  <div class="col-6 detail-item">
                    <div class="detail-label">In data</div>
                    <div class="detail-value">{{ formatTimestampToLocalDate(emergenza.tempo) }}</div>
                  </div>
                </div>

                <div class="modal-section-title mt-2"><i class="mdi mdi-map-marker-outline"></i> Localizzazione</div>
                <div class="detail-item">
                  <div class="detail-label">Strada</div>
                  <div class="detail-value font-weight-bold">{{ emergenza.strada }}</div>
                </div>
                <div class="row small text-muted">
                    <div class="col-6">Lat: {{ emergenza.latitudine }}</div>
                    <div class="col-6">Lon: {{ emergenza.longitudine }}</div>
                </div>

                <div class="modal-section-title mt-4"><i class="mdi mdi-note-text-outline"></i> Note</div>
                <div class="detail-item">
                  <p class="text-danger font-weight-bold italic" v-if="emergenza.note">{{ emergenza.note }}</p>
                  <p class="text-muted italic small" v-else>Nessuna nota aggiuntiva</p>
                </div>

                <div class="mt-4 pt-3 border-top text-right">
                    <button @click="downloadEmergenza(emergenza)" class="btn btn-outline-primary mr-2 shadow-sm">
                        <i class="mdi mdi-download mr-1"></i> Scarica
                    </button>
                    <button @click="impostaSegnalazioneComeLetta(emergenza.id); $modal.hide('emergenza')" class="btn btn-danger px-4 shadow-sm">
                        <i class="mdi mdi-eye-check-outline mr-1"></i> Segna come Letta
                    </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>      
    </modal>

  </div>
</template>

<script>
import { Navbar, DeveloperDashboard } from "@/components";
import { contextStore } from "@/utils/contextStore";
import { nomeIntervento } from "@/utils/intervento";

export default {
  components: {
    Navbar,
    DeveloperDashboard
  },

  data() {
    return {
      loading: true,
      report: {
        bucheRiparate: 0,
        squadreAttive: 0,
        squadreTotali: 0,
        strade: 0,
        metriSfalciati: 0,
        puntiLuceRipristinati: 0,
        interventiIgiene: 0,
        alberiPotati: 0,
        interventiIrrigazione: 0
      },
      reportLoading: false,
      reportInterval: undefined,

      tipologia: localStorage.getItem('tipologia'),

      // Teams
      teamsLoading: false,
      progressBarTeams: 0,
      progressBarTeamsInterval: undefined,
      gruppoSelezionato: "Tutte",
      teams: [],
      allTeams: [],
      activeView: "Segnalazioni inviate",

      // Segnalazioni
      segnalazioniLoading: false,
      progressBarSegnalazioni: 0,
      progressBarSegnalazioniInterval: undefined,
      forceRefreshSegnalazione: true,
      segnalazioneDaAssociare: 0,
      teamDaAssociareASegnalazione: 0,
      segnalazione: {},
      segnalazioni: [],

      // Richieste di supporto
      richiesteLoading: false,
      progressBarRichieste: 0,
      progressBarRichiesteInterval: undefined,
      forceRefreshRichiesta: true,
      richiestaDaAssociare: 0,
      teamDaAssociareARichiesta: 0,
      richiesta: {},
      richieste: [],

      // Lavori in corso
      lavoriLoading: false,
      progressBarLavori: 0,
      progressBarLavoriInterval: undefined,
      forceRefreshLavoro: true,
      //richiestaDaAssociare: 0,
      //teamDaAssociareARichiesta: 0,
      lavoro: {},
      lavori: [],

      // Emergenze
      emergenzeLoading: false,
      progressBarEmergenze: 0,
      progressBarEmergenzeInterval: undefined,
      forceRefresEmergenze: true,
      emergenzaDaAssociare: 0,
      emergenza: {},
      emergenze: [],

      // PUSH
      permission: undefined,

      allTeamTypes: JSON.parse(localStorage.getItem("teamTypes") || "[]")
    };
  },

  async mounted(){
    if (this.tipologia !== 'D') {
      const companyId = localStorage.getItem("fk_company");
      await this.loadTeamTypes(companyId);
      await this.fetchCommesse();
      await this.fetchMyModules();
      this.fetchData();
      this.permission = Notification.permission;
      this.toggleNotifications();
    }
  },

  watch: {
    gruppoSelezionato() {
      this.fetchTeams();
    },

    'contextStore.activeCommessaId'() {
      this.fetchDashboardData();
      this.fetchTeams();
      this.fetchAllTeams();
      this.fetchSegnalazioni();
      this.fetchEmergenze();
      this.fetchRichieste();
      this.fetchLavori();
    },

    'contextStore.selectedModuleId'() {
      this.fetchDashboardData();
      this.fetchSegnalazioni();
      this.fetchRichieste();
      this.fetchLavori();
    },

    activeView() {
      localStorage.setItem('activeView', this.activeView);
    }
  },

  computed: {
    contextStore() {
      return contextStore;
    },

    lotto() {
      return contextStore.activeCommessaId || "1";
    },

    commesse() {
      return contextStore.commesse;
    },

    activeModules() {
      return contextStore.activeModules;
    },

    activeCommessa() {
      return contextStore.activeCommessa;
    },

    filteredGroups() {
      if (this.activeModules.length === 0) {
        return this.allTeamTypes;
      }
      const activeModuleCodes = this.activeModules.map(m => m.codice);
      return this.allTeamTypes.filter(t => !t.module || activeModuleCodes.includes(t.module));
    },

    kpiColClass() {
      let count = 0;
      if (this.isModuleActive('manutenzione_strade') && this.isKpiActive('buche_riparate')) count++;
      if (this.isModuleActive('verde_pubblico') && this.isKpiActive('metri_sfalciati')) count++;
      if (this.isModuleActive('verde_pubblico') && this.isKpiActive('alberi_potati')) count++;
      if (this.isModuleActive('verde_pubblico') && this.isKpiActive('interventi_irrigazione')) count++;
      if (this.isModuleActive('pulizia_stradale') && this.isKpiActive('interventi_igiene')) count++;
      if (this.isModuleActive('illuminazione') && this.isKpiActive('punti_luce_ripristinati')) count++;
      
      if (count >= 4) return 'col-12 col-sm-6 col-lg-3 d-flex align-items-stretch mb-3';
      if (count === 3) return 'col-12 col-sm-6 col-lg-4 d-flex align-items-stretch mb-3';
      if (count === 2) return 'col-12 col-sm-6 col-lg-6 d-flex align-items-stretch mb-3';
      return 'col-12 col-sm-12 col-lg-12 d-flex align-items-stretch mb-3';
    }
  },

  created() {
    // Get lotto
    if (localStorage.getItem("lotto")) {
      this.lotto = localStorage.getItem("lotto");
    }   

    // Get active view
    if (localStorage.getItem("activeView")) {
      this.activeView = localStorage.getItem("activeView");
    }  

    // Aggiorno i dati ogni 60 secondi    
    // var self=this;
    // this.reportInterval = setInterval(function(){
    //   self.fetchDashboardData();
    //   self.fetchSegnalazioni();
    //   self.fetchRichieste();
    //   self.fetchLavori();
    // }, 60000);
  },


  // beforeDestroy() {
  //   clearInterval(this.reportInterval);
  // },

  methods: {    
    nomeIntervento,

    // Fetch all data
    fetchData() {
      if (this.tipologia === 'D') return;
      this.fetchDashboardData();
      this.fetchTeams();
      this.fetchAllTeams();
      this.fetchSegnalazioni();
      this.fetchEmergenze();
      this.fetchRichieste();
      this.fetchLavori();
    },

    // REPORT / DASHBOARD
    fetchDashboardData() {
      this.reportLoading = true;
      this.axios.get(`dashboard/${this.lotto}`).then(response=>{
        const data = response.data || {};
        this.report = {
          bucheRiparate: data['buche_riparate'] || 0,
          squadreAttive: data['squadre_attive'] || 0,
          squadreTotali: data['squadre_totali'] || 0,
          strade: data['strade'] || 0,
          metriSfalciati: data['metri_sfalciati'] || 0,
          puntiLuceRipristinati: data['punti_luce_ripristinati'] || 0,
          interventiIgiene: data['interventi_igiene'] || 0,
          alberiPotati: data['alberi_potati'] || 0,
          interventiIrrigazione: data['interventi_irrigazione'] || 0
        }
        this.reportLoading = false;
      }, error => {
        console.log(error);
        var self = this;
        setTimeout(function(){
          self.reportLoading = false;
        },1000)        
      })
    },

    // TEAMS
    // Si ottengono i dati sui team
    fetchTeams() {
      var params = "";
      if (this.gruppoSelezionato != "Tutte") {
        params = "?group=" + this.gruppoSelezionato;
      }      
      this.avviaProgressBarTeams();
      this.axios.get(`teams/${this.lotto}${params}`).then(response => {
        this.teamsLoading = false;
        this.teams = response.data;
      }, error => {
        console.log(error);
        var self = this;
        setTimeout(function(){
          self.teamsLoading = false;
        },1000); 
      });
    },

    fetchAllTeams() {
      this.axios.get(`teams/${this.lotto}`).then(response => {
        this.allTeams = response.data;
      }, error => {
        console.log(error);
      });
    },

    // Gestice il progresso del fetch dei teams
    avviaProgressBarTeams() {
      var self = this;
      this.teamsLoading = true;
      this.progressBarTeams = -25;
      this.progressBarTeamsInterval = setInterval(function(){
        self.progressBarTeams += 25;  
        if ( self.progressBarTeams >= 100 ) {
          self.resettaProgressBarTeams()
        }      
      }, 250);
    },

    resettaProgressBarTeams() {
      clearInterval(this.progressBarTeamsInterval);
      var self = this;
      setTimeout(function(){
        self.progressBarTeams = 100;
      },2000);      
    },

    // SEGNALAZIONI
    // Si ottengono le segnalazioni "da gestire"
    fetchSegnalazioni() {      
      this.avviaProgressBarSegnalazioni();
      let activeInterventions = [];
      if (this.isModuleActive('manutenzione_strade')) {
        activeInterventions.push('buca', 'segnaletica');
      }
      if (this.isModuleActive('verde_pubblico')) {
        activeInterventions.push('sfalcio');
      }
      if (this.isModuleActive('pulizia_stradale')) {
        activeInterventions.push('pulizia');
      }
      let queryStr = activeInterventions.length > 0 ? activeInterventions.join(',') : 'buca,sfalcio,segnaletica,pulizia';
      
      this.axios.get(`notice/${this.lotto}?interventi=${queryStr}`).then(response => {        
        this.segnalazioni = response.data;
        this.segnalazioniLoading = false;
      }, error => {
        console.log(error);
        var self = this;
        setTimeout(function(){
          self.segnalazioniLoading = false;
        }, 2000);        
      });
    },

    fetchCommesse() {
      const companyId = localStorage.getItem("fk_company");
      if (!companyId) return Promise.resolve();
      return this.axios.get(`/companies/${companyId}/commesse`).then(res => {
        this.commesse = Array.isArray(res.data) ? res.data : [];
        if (this.commesse.length > 0) {
          const savedLotto = localStorage.getItem("lotto");
          const exists = this.commesse.some(c => String(c.id) === String(savedLotto));
          if (exists) {
            this.lotto = savedLotto;
          } else {
            this.lotto = this.commesse[0].id;
            localStorage.setItem("lotto", this.lotto);
          }
        }
      }).catch(err => {
        console.error("Errore recupero commesse:", err);
      });
    },

    loadTeamTypes(companyId) {
      const defaultTeamTypes = [
        { value: "1", label: "Manutenzione stradale", module: "manutenzione_strade", initials: "MS" },
        { value: "2", label: "Manutenzione aree verdi", module: "verde_pubblico", initials: "MAV" },
        { value: "3", label: "Installazione impianto", module: "illuminazione", initials: "II" },
        { value: "4", label: "Riparazione guasti", module: "illuminazione", initials: "RG" },
        { value: "5", label: "Controllo impianti", module: "illuminazione", initials: "CI" },
        { value: "6", label: "Manutenzione ordinaria", module: "manutenzione_strade", initials: "MO" },
        { value: "7", label: "Gestione emergenza", module: "manutenzione_strade", initials: "GE" },
        { value: "8", label: "Pulizia e sanificazione", module: "pulizia_stradale", initials: "PP" },
        { value: "9", label: "Controllo qualità", module: "manutenzione_strade", initials: "CQ" }
      ];
      if (!companyId) {
        this.allTeamTypes = defaultTeamTypes;
        localStorage.setItem("teamTypes", JSON.stringify(defaultTeamTypes));
        return Promise.resolve();
      }
      return this.axios.get(`/companies/${companyId}/tipologie-squadra`).then(response => {
        const customTypes = Array.isArray(response.data) ? response.data : [];
        const mappedCustom = customTypes.map(t => ({
          value: String(t.id),
          label: t.nome,
          module: t.module_code || "",
          initials: t.codice || ""
        }));
        const merged = [...defaultTeamTypes, ...mappedCustom];
        this.allTeamTypes = merged;
        localStorage.setItem("teamTypes", JSON.stringify(merged));
      }).catch(err => {
        console.error("Errore recupero tipologie squadra:", err);
      });
    },

    fetchMyModules() {
      if (!this.lotto) return Promise.resolve();
      return this.axios.get(`/commesse/${this.lotto}/modules`).then(response => {
        this.activeModules = Array.isArray(response.data) ? response.data : [];
      }).catch(err => {
        console.error("Errore nel recupero moduli commessa:", err);
      });
    },

    formatCurrency(value) {
      if (!value) return "N/D";
      const num = parseFloat(value);
      if (isNaN(num)) return value;
      return new Intl.NumberFormat("it-IT", {
        style: "currency",
        currency: "EUR"
      }).format(num);
    },

    formatDate(dateStr) {
      if (!dateStr) return "N/D";
      try {
        const d = new Date(dateStr);
        if (isNaN(d.getTime())) return dateStr;
        return d.toLocaleDateString("it-IT");
      } catch (e) {
        return dateStr;
      }
    },

    isModuleActive(moduleCode) {
      if (contextStore.selectedModuleId) {
        const selectedMod = this.activeModules.find(m => String(m.id) === String(contextStore.selectedModuleId));
        if (selectedMod) {
          return selectedMod.codice === moduleCode;
        }
      }
      if (this.activeModules.length === 0) {
        return true;
      }
      return this.activeModules.some(m => m.codice === moduleCode);
    },

    isKpiActive(kpiCode) {
      if (!this.activeCommessa) return true;
      const kpis = this.activeCommessa.active_kpis;
      if (!kpis) return true;
      return kpis.includes(kpiCode);
    },

    // Gestice il progresso del fetch delle segnalazioni
    avviaProgressBarSegnalazioni() {
      var self = this;
      this.segnalazioniLoading = true;
      this.progressBarSegnalazioni = -20;
      this.progressBarSegnalazioniInterval = setInterval(function(){
        self.progressBarSegnalazioni += 20;
        if ( self.progressBarSegnalazioni >= 100 ) {
          self.resettaProgressBarSegnalazioni()
        }
      }, 400);
    },

    resettaProgressBarSegnalazioni() {
      clearInterval(this.progressBarSegnalazioniInterval);
      var self = this;
      setTimeout(function(){
        self.progressBarSegnalazioni = 100;
      },2000);      
    },

    // Associa una segnalazione ad una squadra
    associaSegnalazioneASquadra() {
      if (this.teamDaAssociareASegnalazione != 0){
        var jsonBody = {
          team: this.teamDaAssociareASegnalazione
        }
        this.axios.post(`notice/${this.lotto}/send/${this.segnalazioneDaAssociare}`, jsonBody).then(response=>{
          if(response.data['success']){
            this.$swal.fire(
              'Perfetto!',
              'Team correttamente assegnato alla segnalazione',
              'success'
            )          
            this.fetchSegnalazioni();
          }
        })
      }      
    },

    // Imposta segnalazione come letta
    impostaSegnalazioneComeLetta(id_segnalazione) {
      this.$swal
        .fire({
          title: "Sicuro?",
          text: "La segnalazione verrà archiviata e sarà disponibile in Mostra > Segnalazioni",
          type: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          cancelButtonText: "No",
          confirmButtonText: "Sì, archivia"
        })
        .then(result => {
          if (result.value) {
            this.axios.put(`notice/${this.lotto}/read/${id_segnalazione}`).then(response=>{
            if(response.data['success']){
              this.$swal.fire(
                'Perfetto!',
                'Hai correttamente archiviato la segnalazione, da ora sarà disponibile nella sezione "storico"',
                'success'
              )  
              this.fetchSegnalazioni();
            }
          })
          }
        });
    },

    // RICHIESTE
    // Si ottengono le richieste "da gestire"
    fetchRichieste() {      
      this.avviaProgressBarRichieste();
      this.axios.get(`support/${this.lotto}`).then(response => {        
        this.richieste = response.data;
        this.richiesteLoading = false;
      }, error => {
        console.log(error);
        var self = this;
        setTimeout(function(){
          self.richiesteLoading = false;
        }, 2000);        
      });
    },

    // Gestice il progresso del fetch delle richieste
    avviaProgressBarRichieste() {
      var self = this;
      this.richiesteLoading = true;
      this.progressBarRichieste = -20;
      this.progressBarRichiesteInterval = setInterval(function(){
        self.progressBarRichieste += 20;
        if(self.progressBarRichieste >= 100) {
          self.resettaProgressBarRichieste();
        }
      }, 400);
    },

    resettaProgressBarRichieste() {
      clearInterval(this.progressBarRichiesteInterval);
      var self = this;
      setTimeout(function(){
        self.progressBarRichieste = 100;
      },2000);      
    },

    // Associa una richiesta ad una squadra
    associaRichiestaASquadra() {
      if (this.teamDaAssociareARichiesta != 0){
        var jsonBody = {
          team: this.teamDaAssociareARichiesta
        }
        this.axios.post(`support/${this.lotto}/send/${this.richiestaDaAssociare}`, jsonBody).then(response=>{
          if(response.data['success']){
            this.$swal.fire(
              'Perfetto!',
              'Team correttamente assegnato alla richiesta',
              'success'
            )          
            this.fetchRichieste();
          }
        })
      }      
    },

    // LAVORI
    // Si ottengono i lavori in corso
    fetchLavori() {      
      this.avviaProgressBarLavori();
      this.axios.get(`dockyard/${this.lotto}`).then(response => {        
        this.lavori = response.data;
        this.lavoriLoading = false;
      }, error => {
        console.log(error);
        var self = this;
        setTimeout(function(){
          self.lavoriLoading = false;
        }, 2000);        
      });
    },

    // Gestice il progresso del fetch delle richieste
    avviaProgressBarLavori() {
      var self = this;
      this.lavoriLoading = true;
      this.progressBarLavori = -20;
      this.progressBarLavoriInterval = setInterval(function(){
        self.progressBarLavori += 20;
        if(self.progressBarLavori >= 100) {
          self.resettaProgressBarLavori();
        }
      }, 400);
    },

    resettaProgressBarLavori() {
      clearInterval(this.progressBarLavoriInterval);
      var self = this;
      setTimeout(function(){
        self.progressBarLavori = 100;
      },2000);      
    },

    downloadLavoroPDF(lavoro) {
      if (!lavoro || !lavoro.uuid) return;
      this.$swal.fire({
        title: "Generazione PDF...",
        text: "Attendere la creazione della relazione.",
        allowOutsideClick: false,
        didOpen: () => {
          this.$swal.showLoading();
        }
      });

      this.axios({
        url: `dockyard/${lavoro.uuid}/pdf`,
        method: 'GET',
        responseType: 'blob',
      })
      .then((response) => {
        this.$swal.close();
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', `Relazione_Lavoro_${lavoro.id || lavoro.uuid}.pdf`);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      })
      .catch((error) => {
        console.error("Errore download PDF:", error);
        this.$swal.close();
        this.$swal.fire({
          icon: "error",
          title: "Errore",
          text: "Impossibile generare la relazione in formato PDF.",
        });
      });
    },

    // EMERGENZE
    // Si ottengono le emergenze 
    fetchEmergenze() {      
      this.avviaProgressBarEmergenze();
      let activeEmergencies = [];
      if (this.isModuleActive('pulizia_stradale')) {
        activeEmergencies.push('rifiuto', 'rifiuto_speciale');
      }
      if (this.isModuleActive('manutenzione_strade') || this.isModuleActive('pulizia_stradale')) {
        activeEmergencies.push('emergenza_carreggiata');
      }
      let queryStr = activeEmergencies.length > 0 ? activeEmergencies.join(',') : 'emergenza_carreggiata,rifiuto_speciale,rifiuto';
      
      this.axios.get(`notice/${this.lotto}?interventi=${queryStr}`).then(response => {        
        this.emergenze = response.data;
        this.emergenzeLoading = false;
      }, error => {
        console.log(error);
        var self = this;
        setTimeout(function(){
          self.emergenzeLoading = false;
        }, 2000);        
      });
    },

    // Gestice il progresso del fetch delle emergenze
    avviaProgressBarEmergenze() {
      var self = this;
      this.emergenzeLoading = true;
      this.progressBarEmergenze = -20;
      this.progressBarEmergenzeInterval = setInterval(function(){
        self.progressBarEmergenze += 20;
        if ( self.progressBarEmergenze >= 100 ) {
          self.resettaProgressBarEmergenze()
        }
      }, 400);
    },

    resettaProgressBarEmergenze() {
      clearInterval(this.progressBarEmergenzeInterval);
      var self = this;
      setTimeout(function(){
        self.progressBarEmergenze = 100;
      },2000);      
    },

    downloadEmergenza(emergenza) {
      var backupEmergenza = JSON.parse(JSON.stringify(emergenza))
      backupEmergenza['data'] = new Date ( backupEmergenza['tempo'] * 1000).toLocaleDateString();
      this.axios.post(`report/emergenza`, backupEmergenza, {responseType: 'blob'}).then(response=>{
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', `${emergenza.intervento}_${emergenza.strada}_${emergenza.id}.pdf`);
        document.body.appendChild(link);
        link.click();
      })
    },

    // Viene cambiata la commessa
    // da 1 a 2 o viceversa
    cambiaCommessa() {
      if (this.lotto == 1) {
        this.lotto = 2;
      } else {
        this.lotto = 1;
      }
      localStorage.setItem("lotto", this.lotto);
    },

    // Mostra il modale con i dettagli di una 
    // segnalazione
    mostraDettagliSegnalazione(segnalazione) {
      this.segnalazione = segnalazione;
      this.$modal.show('segnalazione');
      // turnaround
      this.forceRefreshSegnalazione = !this.forceRefreshSegnalazione;
      this.forceRefreshSegnalazione = !this.forceRefreshSegnalazione;
      // turnaround end
    },

    // Mostra il modale con i dettagli di una 
    // richiesta
    mostraDettagliRichiesta(richiesta) {
      this.richiesta = richiesta;
      this.$modal.show('richiesta');
      // turnaround
      this.forceRefreshRichiesta = !this.forceRefreshRichiesta;
      this.forceRefreshRichiesta = !this.forceRefreshRichiesta;
      // turnaround end
    },

    // Mostra il modale con i dettagli di un
    // lavoro in corso
    mostraDettagliLavoro(lavoro) {
      this.lavoro = lavoro;
      this.$modal.show('lavoro');
      // turnaround
      this.forceRefreshLavoro = !this.forceRefreshLavoro;
      this.forceRefreshLavoro = !this.forceRefreshLavoro;
      // turnaround end
    },

    // Mostra il modale con i dettagli di una 
    // segnalazione
    mostraDettagliEmergenza(emergenza) {
      this.emergenza = emergenza;
      this.$modal.show('emergenza');
      // turnaround
      this.forceRefreshEmergenza = !this.forceRefreshEmergenza;
      this.forceRefreshEmergenza = !this.forceRefreshEmergenza;
      // turnaround end
    },

    classeInterventoBadge(intervento) {
      if (!intervento) return 'badge-soft-secondary';
      const lower = typeof intervento === 'string' ? intervento.toLowerCase() : String(intervento).toLowerCase();
      if (lower.includes('buca')) {
        return 'badge-soft-success';
      }      
      if (lower.includes('sfalcio')) {
        return 'badge-soft-primary';
      }      
      if (lower.includes('segnaletica')) {
        return 'badge-soft-info';
      }      
      if (lower.includes('rifiuto_speciale')) {
        return 'badge-soft-purple';
      }      
      if (lower.includes('rifiuto')) {
        return 'badge-soft-warning';
      }      
      if (lower.includes('emergenza') || lower.includes('palo')) {
        return 'badge-soft-danger';
      }      
      if (lower.includes('pulizia') || lower.includes('cestino')) {
        return 'badge-soft-info';
      }
      return 'badge-soft-secondary';
    },

    // Format Timestamp to Local Date
    formatTimestampToLocalDate(ts){
      const today = new Date();
      var tsDate = new Date(ts*1000);
      if (today.getDate() == tsDate.getDate() && today.getMonth() == tsDate.getMonth() && today.getFullYear() == tsDate.getFullYear()) {
        return `Oggi, ${tsDate.toLocaleTimeString()}`
      } else {
        return tsDate.toLocaleString();
      }
    },

    /**
      Toggle notifications

      Enable / disable desktop notifications
     */
    toggleNotifications() {
      if (Notification.permission === "granted") {
        navigator.serviceWorker.ready.then(() => {
          this.getUserRegistrationToken();
        });
      } else if (Notification.permission !== "denied") {
        Notification.requestPermission().then(permission => {
          if (permission === "granted") {
            navigator.serviceWorker.ready.then(() => {
              this.getUserRegistrationToken();
            });
          }
          this.permission = permission;
        });
      }
    },

    changeNotificationPermission(){
      var self = this;
      Notification.requestPermission().then(function (permission) {
      // If the user accepts, let's create a notification
        if (permission === "granted") {
          console.log('Notifcation granted')
        } else {
          console.log('Check for notifications')
          self.$swal.fire('Abilita le notifiche PUSH', 'Le notifiche per questo dispositivo sono state disabilitate. Si prega di riattivarle tramite le impostazioni del browser.', 'warning')
        }
      });
    },

    /**
      Get user registration token for firebase CM

      Initially this makes a network call, once retrieved
      subsequent calls to getToken will return from cache.
     */
    getUserRegistrationToken() {
      this.$messaging
        .getToken()
        .then(currentToken => {
          if (currentToken) {
            this.sendTokenToServer(currentToken);
          }
        })
        .catch(err => {
          console.log("An error occurred while retrieving token. ", err);
        });
    },

    /**
      Send notification token to server
     */
    sendTokenToServer(tok) {
      var formData = new FormData();
      formData.append("notification_token", tok);
      this.axios.post("/notifications", formData).then(
        response => {
          if (response.data["success"]) {
            console.log("FCM Token registered successfully on server.");
            localStorage.setItem("notification_token", tok);
          }
        },
        error => {
          console.log(error)
          this.$swal.fire({
            type: "error",
            title: "Errore",
            text: "Errore nella attivazione delle notifiche PUSH"
          });
        }
      );
    },
  }
};
</script>

<style scoped>
/* =========================================
   HOMEPAGE — Premium UI (RoadME DS)
   ========================================= */

/* ── Shared tokens from style.md ── */
.cw-section-title {
  font-size: 0.82rem; font-weight: 700;
  text-transform: uppercase; letter-spacing: 0.08em;
  color: #64748b; margin-bottom: 22px;
  display: flex; align-items: center;
}
.cw-step-num {
  width: 22px; height: 22px; border-radius: 50%;
  background: linear-gradient(135deg, #F7931E, #E07B00);
  color: #fff; font-size: 0.7rem; font-weight: 800;
  display: inline-flex; align-items: center; justify-content: center;
  margin-right: 10px; flex-shrink: 0;
}
.cw-label {
  font-size: 0.75rem; font-weight: 700;
  text-transform: uppercase; letter-spacing: 0.07em;
  color: #94a3b8; margin-bottom: 8px; display: block;
}
.cw-input-wrap { position: relative; display: flex; align-items: center; }
.cw-field-icon {
  position: absolute; left: 12px;
  color: #94a3b8; font-size: 1rem; z-index: 2; pointer-events: none;
}
.cw-input {
  width: 100%; height: 46px; padding: 0 14px 0 36px;
  border: 1.5px solid #e2e8f0; border-radius: 10px;
  background: #f8fafc; font-size: 0.92rem; font-weight: 500; color: #1e293b;
  transition: border-color 0.2s, box-shadow 0.2s; outline: none;
}
.cw-input:focus {
  border-color: #F7931E; box-shadow: 0 0 0 3px rgba(247,147,30,0.12); background: #fff;
}
.cw-select-wrap { position: relative; display: flex; align-items: center; }
.cw-select {
  width: 100%; height: 46px; padding: 0 38px 0 36px;
  border: 1.5px solid #e2e8f0; border-radius: 10px;
  background: #f8fafc; appearance: none; -webkit-appearance: none;
  font-size: 0.92rem; font-weight: 500; color: #1e293b;
  cursor: pointer; transition: border-color 0.2s, box-shadow 0.2s; outline: none;
}
.cw-select:focus {
  border-color: #F7931E; box-shadow: 0 0 0 3px rgba(247,147,30,0.12); background: #fff;
}
.cw-select-arrow {
  position: absolute; right: 14px;
  color: #94a3b8; font-size: 1rem; pointer-events: none;
}
.cw-btn-submit {
  display: inline-flex; align-items: center;
  padding: 10px 24px; border: none; border-radius: 30px;
  background: linear-gradient(135deg, #F7931E, #E07B00);
  color: #fff; font-size: 0.88rem; font-weight: 700;
  cursor: pointer; box-shadow: 0 4px 14px rgba(247,147,30,0.35);
  transition: all 0.2s;
}
.cw-btn-submit:hover:not(:disabled) {
  background: linear-gradient(135deg, #E07B00, #C96A00);
  box-shadow: 0 6px 18px rgba(247,147,30,0.45); transform: translateY(-1px);
}
.cw-btn-submit:disabled { opacity: 0.55; cursor: not-allowed; transform: none; }
.cw-footer {
  background: #fff; border-radius: 14px;
  padding: 18px 24px; border: 1px solid rgba(0,0,0,0.05);
  box-shadow: 0 2px 12px rgba(0,0,0,0.05);
}

/* ── Page-specific ── */

/* Header icon */
.au-header-icon {
  width: 48px; height: 48px; border-radius: 14px;
  background: linear-gradient(135deg, #F7931E, #E07B00);
  display: flex; align-items: center; justify-content: center;
  box-shadow: 0 4px 12px rgba(247,147,30,0.35); flex-shrink: 0;
}
.au-header-icon .mdi { color: #fff; font-size: 1.5rem; }

/* Card */
.au-card {
  background: #fff; border-radius: 16px;
  box-shadow: 0 2px 16px rgba(0,0,0,0.07);
  padding: 28px; border: 1px solid rgba(0,0,0,0.05);
}

/* Table */
.au-table { width: 100%; border-collapse: collapse; }
.au-table thead tr { border-bottom: 2px solid #f1f5f9; }
.au-table thead th {
  padding: 10px 16px; font-size: 0.72rem; font-weight: 700;
  text-transform: uppercase; letter-spacing: 0.07em; color: #94a3b8; background: #f8fafc;
}
.au-table tbody tr { border-bottom: 1px solid #f1f5f9; transition: background 0.15s; }
.au-table tbody tr:hover { background: #f8fafc; }
.au-table td { padding: 14px 16px; vertical-align: middle; }
</style>
<style scoped>
/* Modal Specifics */
.modal-header-premium {
  padding: 20px 24px;
  background: #fff;
  border-bottom: 1px solid #f1f5f9;
  border-radius: 12px 12px 0 0;
}
.modal-section-title {
  font-size: 0.85rem; font-weight: 700;
  text-transform: uppercase; letter-spacing: 0.08em;
  color: #64748b; margin-bottom: 16px; margin-top: 10px;
  display: flex; align-items: center; border-bottom: 1px solid #f1f5f9; padding-bottom: 8px;
}
.modal-section-title .mdi { margin-right: 6px; font-size: 1.1rem; color: #F7931E; }
.detail-item { margin-bottom: 12px; }
.detail-label { font-size: 0.72rem; color: #94a3b8; text-transform: uppercase; letter-spacing: 0.05em; margin-bottom: 4px; font-weight: 600; }
.detail-value { font-size: 0.95rem; color: #1e293b; font-weight: 500; }

.badge-soft-primary {
  background-color: rgba(247, 147, 30, 0.1) !important;
  color: #E07B00 !important;
  border: 1.5px solid rgba(247, 147, 30, 0.15) !important;
  font-weight: 600;
}
</style>
